var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('permit-to-work',{attrs:{"site-id":_vm.site.id}})}
var staticRenderFns = []

export { render, staticRenderFns }